import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { RootState } from './store';
import { OnboardDevicesOnlinePeersResponse } from '../interfaces';
import { getOnboardDevicesOnlinePeers } from '../api/getOnboardDevicesOnlinePeers';

export interface OnboardDevicesOnlinePeersState {
    items: OnboardDevicesOnlinePeersResponse | null;
    loading: boolean;
    error: string | null;
}

const initialState: OnboardDevicesOnlinePeersState = {
    items: null,
    loading: false,
    error: null,
};

export const loadOnboardDevicesOnlinePeers = createAsyncThunk('onboardDevicesOnlinePeers/load', async () => {
    return await getOnboardDevicesOnlinePeers();
});

export const OnboardDevicesOnlinePeersSlice = createSlice({
    name: 'onboardDevicesOnlinePeers',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadOnboardDevicesOnlinePeers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loadOnboardDevicesOnlinePeers.fulfilled, (state, action) => {
                state.items = action.payload;
                state.loading = false;
            })
            .addCase(loadOnboardDevicesOnlinePeers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to load online peers.';
                console.error(action.error);
            });
    },
});

export const selectOnboardDevicesOnlinePeers = (state: RootState) => state.onboardDevicesOnlinePeers.items;
export const selectOnboardDevicesOnlinePeersLoading = (state: RootState) =>
    state.onboardDevicesOnlinePeers.loading;
export const selectOnboardDevicesOnlinePeersError = (state: RootState) =>
    state.onboardDevicesOnlinePeers.error;

export default OnboardDevicesOnlinePeersSlice.reducer;
